export class UpdateDisplayMessageSettings{
    MessageType: string;
    Value: boolean

    constructor(messageType: string, value: boolean){
        this.MessageType = messageType;
        this.Value = value;
    }
}